/* eslint-disable react/prop-types */
import { useEffect, useState } from 'react';
import Card from '@mui/material/Card';
import { formatVndIntegerValue } from 'utils';
import SoftBox from 'components/SoftBox';
import DashboardLayout from 'examples/LayoutContainers/DashboardLayout';
import DashboardNavbar from 'examples/Navbars/DashboardNavbar';
import DataTable from './DataTable';
import ActionCell from './components/ActionCell';
import { AccountingDocumentRegisterService } from 'services/accounting-document-register';

const currentDate = new Date();
const defaultYear = String(currentDate.getFullYear());
const defaultMonth = String(currentDate.getMonth() + 1).padStart(2, '0');

const renderData = (items, setDataTable, query) =>
  items.map((item) => {
    const searchParams = new URLSearchParams({
      year: String(query.year || defaultYear),
      month: String(query.month || defaultMonth),
      searchBy: String(item.voucherNumber || ''),
    }).toString();

    return {
      id: item.id,
      voucherNumber: item.voucherNumber,
      voucherDate: item.voucherDate,
      amount: formatVndIntegerValue(item.amount || 0),
      action: (
        <ActionCell
          item={{
            id: item.id,
            voucherNumber: item.voucherNumber,
            viewLink: `/templates/accounting-document-register/view?${searchParams}`,
          }}
          setDataTable={setDataTable}
        />
      ),
    };
  });

const tableData = {
  columns: [
    { Header: 'Số CTGS', accessor: 'voucherNumber' },
    { Header: 'Ngày CTGS', accessor: 'voucherDate' },
    { Header: 'Số tiền', accessor: 'amount' },
    { Header: 'Actions', accessor: 'action', sorted: false },
  ],
  rows: [],
};

export default function AccountingDocumentRegister() {
  const [loading, setLoading] = useState(false);
  const [dataTable, setDataTable] = useState(tableData);
  const [query, setQuery] = useState({
    year: defaultYear,
    month: defaultMonth,
    searchBy: '',
    sortBy: 'voucherDate',
    sortType: 'asc',
  });
  const [paginationData, setPaginationData] = useState({ page: 1, count: 0, size: 10 });

  useEffect(() => {
    fetchData();
  }, [query, paginationData.page]);

  const fetchData = async () => {
    try {
      setLoading(true);
      const response = await AccountingDocumentRegisterService.getPaginate({
        ...query,
        page: paginationData.page,
        limit: paginationData.size,
      });

      const { items, paginate } = response.data || response;

      setPaginationData((prev) => ({
        ...prev,
        count: paginate?.count || 0,
        size: paginate?.size || 10,
      }));

      setDataTable((prev) => ({
        ...prev,
        rows: renderData(items || [], setDataTable, query),
      }));
    } catch (error) {
      setDataTable((prev) => ({ ...prev, rows: [] }));
    } finally {
      setLoading(false);
    }
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <SoftBox my={3}>
        <Card style={{ height: '100%' }}>
          <DataTable
            query={query}
            table={dataTable}
            paginationData={paginationData}
            setPaginationData={setPaginationData}
            loading={loading}
            onApplyFilters={(nextQuery) => setQuery((prev) => ({ ...prev, ...nextQuery }))}
            onResetFilters={(nextQuery) => setQuery((prev) => ({ ...prev, ...nextQuery }))}
          />
        </Card>
      </SoftBox>
    </DashboardLayout>
  );
}
